export default __webpack_public_path__ + "static/media/increase-engagement.b58cd949.svg";